import AxiosInstance from "./api";

export const OvertimePaymentTableService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/overtime-table", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/overtime-table/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/overtime-table", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/overtime-table/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/overtime-table/" + id);
  },
};
